"use client";

import Image from "next/image";
import { useTranslations } from "next-intl";
import { useScrollAnimation } from "@/hooks/use-scroll-animation";

export function FeaturesSection() {
  const t = useTranslations("Home.benefits");
  const block1Animation = useScrollAnimation({ threshold: 0.2 });
  const block2Animation = useScrollAnimation({ threshold: 0.2 });
  const block3Animation = useScrollAnimation({ threshold: 0.2 });
  return (
    <section className="py-24 px-4 sm:px-8 relative overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-b from-black via-gray-900/50 to-black"></div>
      <div className="relative z-10 max-w-7xl mx-auto">
        {/* Bloque 1: Confianza y Autoestima - Imagen izquierda, Texto derecha */}
        <div
          ref={block1Animation.ref}
          className={`flex flex-col lg:grid lg:grid-cols-2 gap-8 lg:gap-12 lg:items-center mb-24 transition-all duration-1000 ease-out ${
            block1Animation.isVisible
              ? "opacity-100 translate-y-0"
              : "opacity-0 translate-y-8"
          }`}
        >
          <div className="w-full">
            <div className="aspect-[1/1] sm:aspect-[1/1] relative overflow-hidden rounded-lg">
              <Image
                src="/images/adrian-y-anita-sonriendo-mirando-a-camara-medio-cuerpo.webp"
                alt={t("block1.imageAlt")}
                fill
                className="object-contain"
                sizes="(max-width: 768px) 100vw, 50vw"
              />
            </div>
          </div>
          <div className="space-y-6">
            <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-white leading-tight font-[family-name:var(--font-big-shoulders)] uppercase">
              {t("block1.title")}
            </h2>
            <p className="text-base sm:text-lg text-gray-300 leading-relaxed">
              {t("block1.description")}
            </p>
          </div>
        </div>

        {/* Bloque 2: Conexión y Disfrute - Texto izquierda, Imagen derecha */}
        <div
          ref={block2Animation.ref}
          className={`flex flex-col lg:grid lg:grid-cols-2 gap-8 lg:gap-12 lg:items-center mb-24 transition-all duration-1000 ease-out ${
            block2Animation.isVisible
              ? "opacity-100 translate-y-0"
              : "opacity-0 translate-y-8"
          }`}
        >
          <div className="w-full lg:order-2">
            <div className="aspect-[4/5] sm:aspect-[4/5] relative overflow-hidden rounded-lg">
              <Image
                src="/images/adrian-y-anita-bailando-con-complicidad.webp"
                alt={t("block2.imageAlt")}
                fill
                className="object-contain"
                sizes="(max-width: 768px) 100vw, 50vw"
              />
            </div>
          </div>
          <div className="space-y-6 lg:order-1">
            <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-white leading-tight font-[family-name:var(--font-big-shoulders)] uppercase">
              {t("block2.title")}
            </h2>
            <p className="text-base sm:text-lg text-gray-300 leading-relaxed">
              {t("block2.description")}
            </p>
          </div>
        </div>

        {/* Bloque 3: Excelencia y Reconocimiento - Imagen izquierda, Texto derecha */}
        <div
          ref={block3Animation.ref}
          className={`flex flex-col lg:grid lg:grid-cols-2 gap-8 lg:gap-12 lg:items-center transition-all duration-1000 ease-out ${
            block3Animation.isVisible
              ? "opacity-100 translate-y-0"
              : "opacity-0 translate-y-8"
          }`}
        >
          <div className="w-full">
            <div className="aspect-[4/5] sm:aspect-[4/5] relative overflow-hidden rounded-lg">
              <Image
                src="/images/adrian-y-anita-de-verde-exhibiendo-maestria.webp"
                alt={t("block3.imageAlt")}
                fill
                className="object-contain"
                sizes="(max-width: 768px) 100vw, 50vw"
              />
            </div>
          </div>
          <div className="space-y-6">
            <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-white leading-tight font-[family-name:var(--font-big-shoulders)] uppercase">
              {t("block3.title")}
            </h2>
            <p className="text-base sm:text-lg text-gray-300 leading-relaxed">
              {t("block3.description")}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
